import React, { useState, useEffect, Suspense, lazy } from "react";
import { NavLink } from "react-router-dom";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import Loader from "../../componants/loader/Loader";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import toastNotify from "../../utils/ToastNotify";
import { BiCategory, BiChevronRight, BiFile, BiHomeAlt, BiLabel, BiLeftArrowAlt, BiNews } from "react-icons/bi";
import SelectField from "../../componants/textField/SelectField";

const Documents = lazy(() => import('../dashboard/Documents'));

const News = () => {
  const [newsKnowledge, setNewsKnowledge] = useState([]);
  const dispatch = useDispatch();
  const screenWidth = useSelector((state) => state.layout.currentScreenWidth);
  const [selectedId, setSelectedId] = useState("");
  const [selectedCategory, setSelectedCategory] = useState([]);

  const fetchNewsKnowledge = (async () => {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest("POST", urls.getNewsKnowledge, {}, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setNewsKnowledge(response);
        setSelectedId(response[0].CAT_NM);
        setSelectedCategory(response[0]);
      } else {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  })

  useEffect(() => {
    fetchNewsKnowledge();
  }, []);

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row date-time container-top">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="pb-2">
              <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
              <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                Dashboard /
              </NavLink>
              <span className="navigation-header-text ps-1 ">
                News &amp; Knowledge
              </span>
            </div>
          </div>
        </div>
        {/* {!isReadMore && */}
        <Row>
          <Col lg={4}>
            {screenWidth >= 933 &&
              <div className="pb-2">
                <BiCategory className="me-2" />
                <span className="fw-bold">Category</span>
              </div>
            }

            <Card className={screenWidth >= 875 ? "overflow-hidden" : ""}>
              <Card.Body className="p-0">
                {screenWidth >= 933 ?
                  <ul className="p-0 mb-0">
                    {newsKnowledge &&
                      newsKnowledge.map((category, index) => (
                        <li
                          key={index}
                          className={`help-menu ${selectedCategory.CAT_NM === category.CAT_NM ? "active" : ""}`}
                          onClick={() => setSelectedCategory(category)}
                        >
                          <div className=" w-100">
                            <BiLabel />
                            <span className="manu-list-doc px-2 text-base">
                              {category.CAT_NM}
                              <span>
                                <BiChevronRight className="arrow-icon pt-1" style={{ fontSize: 25 }} />
                              </span>
                            </span>
                          </div>
                        </li>
                      ))}
                  </ul>
                  :
                  <div className='m-3'>
                    <SelectField
                      placeholder="Menu"
                      options={newsKnowledge.map((items) => {
                        return { value: items.CAT_NM, label: items.CAT_NM, data: items }
                      })}
                      value={{ value: selectedId, label: selectedId }}
                      onChange={(e) => { setSelectedId(e?.value); setSelectedCategory(e.data) }}
                    />
                  </div>
                }
              </Card.Body>
            </Card>
          </Col>
          <Col lg={8} className="mt-md-0 mt-3">
            <div className="pb-2">
              <BiFile className="me-2" />
              <span className="fw-bold">News</span>
            </div>
            <Card>
              <Card.Body
                className="p-0"
              >
                <Suspense fallback={<Loader isLoader={true} />}>
                  <Documents data={selectedCategory?.DTL} />
                </Suspense>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* } */}

        {/* {isReadMore && (
          <Card>
            <Card.Body className="p-0">

              <div className='d-flex align-items-center p-2'>
                <div style={{ width: 40, height: 40, backgroundColor: '#f5693650' }} className='rounded-circle d-flex justify-content-center align-items-center me-2'>
                  <BiNews style={{ color: '#f56936' }} />
                </div>
                <div>
                  <div className="text-lg fw-semibold">{readMoreData.TITLE}</div>
                  <div className="text-sm text-slate-500">{readMoreData.DATE}</div>
                </div>
                <Button
                  type="button"
                  variant="warning"
                  className="btn-sm ms-auto"
                  onClick={() => {
                    setReadMoreData(null);
                    setIsReadMore(false);
                  }}
                >
                  <BiLeftArrowAlt className="text-lg me-1" />
                  Back
                </Button>
              </div>
              <hr className="my-0" />
              <div className="p-2">
                <p className="">{readMoreData?.DESCRIPTION}</p>
              </div>
            </Card.Body>
          </Card>
        )} */}

        {newsKnowledge.length === 0 && (
          <>
            <div className="d-flex justify-content-center NoData-image">
              <img
                src="./assets/images/No-data.jpg"
                alt=""
                className="NoData-Size"
              />
            </div>
            <div className="d-flex justify-content-center">
              <h4 className="mt-3"> No Data Found </h4>
            </div>
          </>
        )}
      </div >
    </>
  );
};

export default News;
